import { RainService } from "./rainService";

const rainService = new RainService();
export default rainService;
